function hasClass(classNames, search) {
  if (!classNames) {
    return false;
  }
  return classNames.split(/ +/).includes(search);
}

export default hasClass;
